import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RolesService } from 'src/app/Admin/roles/roles.service';
import { BranchMasterDTO, BranchMasterReadByUserIdRequestDTO } from 'src/app/Common/BranchMasterService/branchmaster.interface';
import { BranchMasterService } from 'src/app/Common/BranchMasterService/branchmaster.service';
import { GetDictionaryDTO } from 'src/app/Common/common.interface';
import { UserBranchSoftwareMappingService } from 'src/app/Common/UserBranchSoftwareMapping/userbranchsoftwaremapping.service';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { UserRoleCreateRequestDTO, UserRoleDeleteRequestDTO, UserRoleDTO, UserRoleReadByUserIdRequestDTO } from 'src/app/Common/UserRolesService/userRole.interface';
import { UserRoleService } from 'src/app/Common/UserRolesService/userRole.service';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { UserDTO, UserReadByUserIdRequestDTO, UserUpdateRequestDTO } from '../../user-master.interface';
import { UserMasterService } from '../../user-master.service';
import { environment } from 'src/environments/environment';
import { UserLoginReadByUserIdRequestDTO, UserLoginUpdateRequestDTO } from 'src/app/Common/UserLoginService/userlogin.interface';
import { passwordMatchValidator } from 'src/app/Shared/validators/passwordMatchValidator';
import { DocumentMasterService } from 'src/app/Common/DocumentMasterService/document-master.service';
import { ensureNumber } from 'src/app/Shared/customFunctions/CustomFunctions';
@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  User = inject(UserLoginService).User();
  userMasterService = inject(UserMasterService);
  userRoleService = inject(UserRoleService);
  userLoginService = inject(UserLoginService);
  UBSM = inject(UserBranchSoftwareMappingService);
  route = inject(ActivatedRoute);
  rolesService = inject(RolesService);
  branchMaster = inject(BranchMasterService);
  documentMasterService = inject(DocumentMasterService);
  public modalService = inject(NgbModal);
  public confirmModal = inject(ConfirmmodalserviceService);
  rolesList: GetDictionaryDTO[] = [];
  filteredRoleList: GetDictionaryDTO[] = [];
  @Output() assignNewRoleEvent = new EventEmitter<number>();
  @ViewChild('assignRoleModalContent', { static: false }) assignRoleModalContent!: ElementRef;

  assignRoleModal!: NgbModalRef;
  isAssigningRole = false;
  cdr = inject(ChangeDetectorRef);

  @ViewChild('resetPasswordModalContent', { static: false }) resetPasswordModalContent!: ElementRef;
  resetPasswordModal!: NgbModalRef;
  resetPasswordForm = new FormGroup({
    loginId: new FormControl(0),
    userId: new FormControl(0),
    userName: new FormControl(''),
    userPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    isActive: new FormControl(0),
    actionUser: new FormControl('')
  },
    { validators: passwordMatchValidator() });

   userProfile: UserDTO = {
    userId: 0,
    tenantId: 0,
    tenantBranchId: 0,
    softwareId: 0,
    isActive: 0,
    createdOn: new Date(),
    modifiedOn: new Date(),
    isDeleted: 0,
    azureUserId: 0,
    pageSize: 0,
    pageNo: 0,
    actionUser: this.User.userId.toString()
  }

  userRoleList: UserRoleDTO[] = [];
  userBranch: BranchMasterDTO[] = [];

  userRoleCreate: UserRoleCreateRequestDTO = {
    softwareId: parseInt(environment.SoftwareId),
    roleId: 0,
    userId: 0,
    tenantId: 0,
    tenantBranchId: 0,
    actionUser: this.User.userId.toString(),
  }

  // --- In-place Edit Properties ---
  isEditMode = false;
  originalUserData: Partial<UserDTO> = {};

  editUserForm = new FormGroup({
    userId: new FormControl(0),
    tenantId: new FormControl(0),
    tenantBranchId: new FormControl(0),
    softwareId: new FormControl(parseInt(environment.SoftwareId)),
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    mobileNo: new FormControl(''),
    emailId: new FormControl('', [Validators.email]),
    designation: new FormControl(''),
    profileImage: new FormControl(''),
    isActive: new FormControl(1),
    actionUser: new FormControl(this.User.userId.toString())
  });

  // --- End In-place Edit Properties ---
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const userId = Number(params.get('id'));


      this.userRoleCreate.userId = userId;
      this.userRoleCreate.softwareId = parseInt(environment.SoftwareId);


      this.GetRolesDictionary();

      const req: UserReadByUserIdRequestDTO = { userId: userId, tenantId: this.User.companyId! };
      this.userMasterService.UserMaster_readById(req).subscribe((res) => {

        this.patchUserData(res);


         this.getUserBranch(this.userProfile.tenantId);
      });


      const req2: UserRoleReadByUserIdRequestDTO = {
        softwareId: 1,
        tenantId: ensureNumber(this.User.companyId),
        tenantBranchId: ensureNumber(this.User.loggedInBranchId),
        userId: userId
      };
      this.userRoleService.UserRole_readByUserId(req2).subscribe((res) => {
        this.userRoleList = res.items;
      });
    });
  }




  // Helper function to check if a field has changed
  isFieldChanged(fieldName: string): boolean {
    const currentValue = this.editUserForm.get(fieldName)?.value;
    const originalValue = this.originalUserData[fieldName as keyof UserDTO];
    return currentValue !== originalValue;
  }

  // Get validation error message for a field
  getFieldError(fieldName: string): string {
    const control = this.editUserForm.get(fieldName);
    if (control?.errors && control.touched) {
      if (control.errors['required']) return `${fieldName} is required`;
      if (control.errors['email']) return 'Please enter a valid email';
      if (control.errors['minlength']) return `${fieldName} is too short`;
    }
    return '';
  }

  selectedImage: string | null = null;
  showImageModal = false;

  viewImage(imageUrl: string): void {
    this.selectedImage = imageUrl;
    this.showImageModal = true;
  }

  closeImageModal(): void {
    this.showImageModal = false;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.onUpload(file);
    }
  }

  onUpload(file: File): void {
    if (file) {
      const formData = new FormData();
      formData.append('File', file, file.name);
      formData.append('TenantId', this.User.companyId.toString());
      formData.append('TenantBranchId', this.User.loggedInBranchId.toString());
      formData.append('SoftwareId', environment.SoftwareId);

      this.documentMasterService.DocumentMaster_Upload(formData).subscribe(
        (response) => {
          this.userProfile.profileImage = response.url;
          console.log(this.userProfile.profileImage);

          const updateRequest: UserDTO = {
            ...this.userProfile,
            profileImage: this.userProfile.profileImage,
          };

          this.userMasterService.UserMaster_update(updateRequest).subscribe(
            () => {
              console.log('Profile image updated in database');

            },
            (error) => {
              console.error('Error updating profile image:', error);

            });
        },
        (error) => {
          console.error('Error uploading file:', error);
        });
    } else {
      alert('Please select a file to upload.');
    }
  }

  GetRolesDictionary() {
    this.rolesService.Roles_getDictionary({ actionUser: this.User.userId.toString() }).subscribe(roleRes => {
      this.rolesList = roleRes.dropDownList;
    });
  }

  assignRole() {
    this.filteredRoleList = this.rolesList.filter(role =>
      this.userRoleList.length === 0 ||
      this.userRoleList.every(userRole => userRole.roleId !== Number(role.key))
    );
    this.isAssigningRole = true;
  }

  addRole() {
    if (this.userRoleCreate.roleId !== 0) {
      this.userRoleService.UserRole_create(this.userRoleCreate).subscribe((res) => {
        this.userRoleList.push(res);
        console.log(res);
      });
      this.filteredRoleList = this.filteredRoleList.filter(role => Number(role.key) != this.userRoleCreate.roleId);
      this.userRoleCreate.roleId = 0;
    }
  }

  deleteUserRole(roleToRemove: any) {
    let req: UserRoleDeleteRequestDTO = {
      userRoleId: roleToRemove.userRoleId,
      tenantId: ensureNumber(this.User.companyId),
      tenantBranchId: ensureNumber(this.User.loggedInBranchId),
      actionUser: this.User.userId.toString(),
    };

    this.userRoleService.UserRole_delete(req).subscribe(() => {
      this.filteredRoleList.push(this.rolesList.find(i => i.key == roleToRemove.roleId) as GetDictionaryDTO);
      this.userRoleList = this.userRoleList.filter(role => role.roleId !== roleToRemove.roleId);
      this.userRoleCreate.roleId = 0;
    });
  }

    getUserBranch(tenantId: number) {
    let req3: BranchMasterReadByUserIdRequestDTO = {
      tenantId: tenantId,
      actionUser: this.User.userId.toString()
    };

    this.branchMaster.BranchMaster_readByUserId(req3).subscribe((res) => {
      this.userBranch = res.items;
    });
  }

  openResetPasswordModal() {
    const request: UserLoginReadByUserIdRequestDTO = {
      userId: this.userProfile.userId,
      tenantId: this.userProfile.tenantId
    };

    this.userLoginService.UserLogin_readByUserId(request).subscribe((res) => {
      if (res) {
        this.resetPasswordForm.patchValue({
          loginId: res.loginId,
          userId: res.userId,
          userName: res.userName,
          isActive: res.isActive,
          actionUser: this.User.userId.toString(),
          userPassword: '',
          confirmPassword: '',
        });
      }
      this.resetPasswordModal = this.modalService.open(this.resetPasswordModalContent);
    });
    this.resetPasswordForm.reset();
  }

  resetUserPassword() {
    this.resetPasswordForm.markAllAsTouched();
    if (this.resetPasswordForm.invalid) return;

    if (this.resetPasswordForm.valid) {
      const newPassword = this.resetPasswordForm.value.userPassword;
      const updatePayload: UserLoginUpdateRequestDTO = {
        loginId: this.resetPasswordForm.value.loginId!,
        userId: this.resetPasswordForm.value.userId!,
        tenantId: this.User.companyId!,
        tenantBranchId: this.User.loggedInBranchId!,
        userName: this.resetPasswordForm.value.userName!,
        userPassword: newPassword!,
        isActive: this.resetPasswordForm.value.isActive!,
        actionUser: this.User.userId.toString(),
      };

      this.userLoginService.UserLogin_update(updatePayload).subscribe({
        next: () => {
          this.resetPasswordForm.reset();
          this.resetPasswordModal.close();
        },
        error: (err) => {
          console.error('Password update failed:', err);
        }
      });
    }
  }

  enterEditMode() {

    this.originalUserData = { ...this.userProfile };


    this.editUserForm.patchValue({
      userId: this.userProfile.userId,
      tenantId: this.userProfile.tenantId,
      tenantBranchId: this.userProfile.tenantBranchId,
      softwareId: parseInt(environment.SoftwareId),
      firstName: this.userProfile.firstName || '',
      middleName: this.userProfile.middleName || '',
      lastName: this.userProfile.lastName || '',
      dob: this.userProfile.dob ? new Date(this.userProfile.dob).toISOString().split('T')[0] : '',
      mobileNo: this.userProfile.mobileNo || '',
      emailId: this.userProfile.emailId || '',
      designation: this.userProfile.designation || '',
      profileImage: this.userProfile.profileImage || '',
      isActive: this.userProfile.isActive,
      actionUser: this.User.userId.toString()
    });

    this.isEditMode = true;

  }

  updateUser() {
    this.editUserForm.markAllAsTouched();

    const formData = this.editUserForm.value;

    const updatePayload: UserUpdateRequestDTO = {
      softwareId: parseInt(environment.SoftwareId),
      userId: formData.userId!,
      tenantId: formData.tenantId!,
      tenantBranchId: formData.tenantBranchId!,
      firstName: formData.firstName!,
      middleName: formData.middleName ?? '',
      lastName: formData.lastName!,
      dob: formData.dob ? new Date(formData.dob) : undefined,
      mobileNo: formData.mobileNo!,
      emailId: formData.emailId ?? '',
      designation: formData.designation ?? '',
      profileImage: formData.profileImage ?? '',
      isActive: formData.isActive!,
      actionUser: this.User.userId.toString()
    };



    // Call API to update user
    this.userMasterService.UserMaster_update(updatePayload).subscribe({
      next: (response) => {

        this.userProfile = response;

        // Update the backup data to reflect the new state
        this.originalUserData = { ...this.userProfile };

        // Reset form and switch to view-only mode
        this.editUserForm.patchValue({
          firstName: this.userProfile.firstName,
          middleName: this.userProfile.middleName,
          lastName: this.userProfile.lastName,
          dob: this.userProfile.dob ? new Date(this.userProfile.dob).toISOString().split('T')[0] : '',
          designation: this.userProfile.designation,
          profileImage: this.userProfile.profileImage,
          mobileNo: this.userProfile.mobileNo,
          emailId: this.userProfile.emailId
        });
        this.isEditMode = false;
      },
      error: (error) => {
        console.error('Error updating user:', error);

      }
    });
  }

  cancelEdit() {

    this.isEditMode = false;
  }

  patchUserData(userData: any) {

    this.userProfile = { ...userData };
    this.originalUserData = { ...userData };

    this.editUserForm.patchValue({
      userId: userData.userId,
      tenantId: userData.tenantId,
      tenantBranchId: userData.tenantBranchId,
      softwareId: parseInt(environment.SoftwareId),
      firstName: userData.firstName || '',
      middleName: userData.middleName || '',
      lastName: userData.lastName || '',
      dob: userData.dob ? new Date(userData.dob).toISOString().split('T')[0] : '',
      mobileNo: userData.mobileNo || '',
      emailId: userData.emailId || '',
      designation: userData.designation || '',
      profileImage: userData.profileImage || '',
      isActive: userData.isActive,
      actionUser: this.User.userId.toString()
    });

  }


}